import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EmailTemplate as EmailTemplateDomain } from '@wsphere/warranties/domain';
import { BehaviorSubject, firstValueFrom, switchMap } from 'rxjs';

export type EmailTemplateEventType = EmailTemplateDomain.EmailType;
export type EmailTemplate = EmailTemplateDomain.Email;
export type EmailTemplateToken = EmailTemplateDomain.EmailToken;
export type CreateEmailTemplateRequest = EmailTemplateDomain.CreateEmailTemplateRequest;
export type UpdateEmailTemplateRequest = EmailTemplateDomain.UpdateEmailTemplateRequest;

export const EMAIL_TEMPLATE_EVENT_TYPES = Object.values(EmailTemplateDomain.EmailType);

export const EMAIL_TEMPLATE_TOKENS = EmailTemplateDomain.EMAIL_TEMPLATE_TOKENS;

@Injectable({ providedIn: 'root' })
export class EmailTemplatesService {
  private readonly refresh$ = new BehaviorSubject<null>(null);

  constructor(private http: HttpClient) {}

  getTemplatesObservable() {
    return this.refresh$.pipe(switchMap(() => this.http.get<EmailTemplate[]>('/api/settings/email-templates')));
  }

  async createTemplate(dto: CreateEmailTemplateRequest): Promise<EmailTemplate> {
    const created = await firstValueFrom(
      this.http.post<EmailTemplateDomain.CreateEmailTemplateResponse>('/api/settings/email-templates', dto)
    );

    this.refresh();

    return { id: created.id } as EmailTemplate;
  }

  async updateTemplate(templateId: string, dto: UpdateEmailTemplateRequest): Promise<EmailTemplate | null> {
    const updated = await firstValueFrom(
      this.http.patch<EmailTemplateDomain.UpdateEmailTemplateResponse>(
        `/api/settings/email-templates/${templateId}`,
        dto
      )
    );

    this.refresh();

    return { id: updated.id } as EmailTemplate;
  }

  refresh() {
    this.refresh$.next(null);
  }
}
